module.exports = __webpack_public_path__ + "img/tether-wifi.52a43ccc.svg";